import type { ReactNode } from 'react'
import type { CustomerAreaNavItem } from './customerAreaLayoutTypes'
import { buildSidebarSections, joinClassNames } from './customerAreaNavShared'
import { CustomerAreaDesktopNavigation } from './CustomerAreaDesktopNavigation'
import { CustomerAreaMobileNavigation } from './CustomerAreaMobileNavigation'

type CustomerAreaNavigationProps = {
  navItems: CustomerAreaNavItem[]
  activeNavId: string
  onNavigate: (targetPath: string) => void
  mainClassName?: string
  children: ReactNode
}

export const CustomerAreaNavigation = ({
  navItems,
  activeNavId,
  onNavigate,
  mainClassName,
  children,
}: CustomerAreaNavigationProps) => {
  const sections = buildSidebarSections(navItems)

  return (
    <>
      <CustomerAreaMobileNavigation navItems={navItems} activeNavId={activeNavId} onNavigate={onNavigate} />

      <div className="grid gap-4 lg:grid-cols-[228px_minmax(0,1fr)] xl:gap-5 2xl:grid-cols-[244px_minmax(0,1fr)]">
        <CustomerAreaDesktopNavigation sections={sections} activeNavId={activeNavId} onNavigate={onNavigate} />
        <main className={joinClassNames('space-y-6', mainClassName)}>{children}</main>
      </div>
    </>
  )
}
